const CarIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={17} height={16} fill="none" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M5.579 4h5.842l1.334 2.667h-8.51L5.58 4Zm-1.412 6.667h-.334V10h1.334a.667.667 0 0 0 0-1.333H3.833V8h9.334v.667h-1.334a.667.667 0 0 0 0 1.333h1.334v.667h-9ZM14.5 7.333c0-.009-.005-.016-.005-.026a.67.67 0 0 0-.041-.203l-.015-.044-.01-.025-2-4a.666.666 0 0 0-.596-.368H5.167a.667.667 0 0 0-.597.368l-2 4c-.004.008-.005.017-.009.025l-.015.044a.669.669 0 0 0-.04.203c-.001.01-.006.017-.006.026v4c0 .043.017.08.024.12-.015.07-.024.14-.024.214v.666c0 .55.45 1 1 1h.667c.55 0 1-.45 1-1V12h6.666v.333c0 .55.45 1 1 1h.667c.55 0 1-.45 1-1v-.666c0-.074-.01-.144-.024-.214.007-.04.024-.077.024-.12v-4Z"
            clipRule="evenodd"
        />
    </svg>
);
export default CarIcon;
